export const Role = {
    Admin: 'ADMIN',
    Coord: 'COORD',
    User: 'USER',
}